const countryData = {

  Quindio: {
    Armenia: '63001',
    Calarca: '63130',
    Circasia: '63190',
    Filandia: '63272',
    Salento: '63690',
    Montenegro: '63470',
    Quimbaya: '63594',
    Barcelona: '63087',
    Cordoba: '63212',
    Genova: '63302',
    Buenavista: '63111',
    Pijao: '63548',
  },

  Risaralda: {
    Pereira: '66001',
    Dosquebradas: '66170',
    'Santa Rosa de Cabal': '66682',
    'La Virginia': '66400',
  },

  Caldas: {
    Manizales: '17001',
    'Chinchiná': '17174',
    'Villamaría': '17873',
  },

  Huila: {
    Neiva: '41001',
    Rivera: '41615',
    Palermo: '41524',
    Campoalegre: '41132',
    Aipe: '41016',
  },

  Tolima: {
    'Ibagué': '73001',
    Chicoral: '73268',
    Espinal: '73268',
    Guamo: '73319',
    'Saldaña': '73671',
    Natagaima: '73483',
    Castilla: '73124',
  },

  Cundinamarca: {
    'Bogotá': '11001',
    Soacha: '25754',
    'Chía': '25175',
    'Cajicá': '25126',
    'Zipaquirá': '25899',
    'Fusagasugá': '25290',
    'Engativá': '11001',
    Madrid: '25430',
    Mosquera: '25473',
    'Sibaté': '25740',
    'La Mesa': '25386',
    Cota: '25214',
    'Facatativá': '25269',
    Melgar: '73449',
    Girardot: '25307',
    Silvania: '25743',
    Funza: '25286',
  },

  'Valle del Cauca': {
    Cali: '76001',
    'Jamundí': '76364',
    Palmira: '76520',
    Yumbo: '76892',
    'Villa Rica': '76895',
    Ginebra: '76306',
    Candelaria: '76130',
    'Puerto Tejada': '19573',
    Padilla: '19533',
    Cerrito: '76248',
    Pradera: '76563',
    Florida: '76275',
    'Tuluá': '76834',
    Buga: '76111',
    'Buga La Grande': '76113',
    'Andalucía': '76036',
    'La Paila': '76895',
    Caicedonia: '76122',
    Ulloa: '76845',
    Cartago: '76147',
    Sevilla: '76736',
    'La Victoria': '76403',
    Obando: '76497',
    'La Unión': '76400',
    'El Dovio': '76250',
    Toro: '76823',
    'Río Frío': '76622',
    Trujillo: '76828',
    Buenaventura: '76109',
  },

  Cauca: {
    Popayan: '19001',
  },

  Antioquia: {
    'Medellín': '05001',
    'La Pintada': '05390',
    'Santa Bárbara': '05679',
    'Santa Fe de Antioquia': '05042',
    'La Estrella': '05380',
    'Itagüí': '05360',
    Sabaneta: '05631',
    Envigado: '05266',
    Guarne: '05318',
    Bello: '05088',
    Copacabana: '05212',
    Rionegro: '05615',
    Yarumal: '05887',
    Girardota: '05308',
  },

  Meta: {
    'Villavicencio': '50001',
  }
};
